import { type StackPacksState, initialStackPacksState } from "./stackPacks/StackPacksState";

export interface EntitiesState {
	stackPacks: StackPacksState;
}

export const initialEntitiesState: EntitiesState = {
	stackPacks: initialStackPacksState,
};
